/**
 * Created by olga on 22.01.2025
 */

BoardTutorialHelper = {};

BoardTutorialHelper.listTutorialWords = function (amount) {
    const game = Game.currentGame;
    const words = [];

    for (let i = 0; i < amount; i++) {
        const word = game.board.words[game.board.words.length - i - 1];
        if (game.board.foundWordsSet[word]) {
            continue;
        }

        words.push(word);
    }

    return words;
};

BoardTutorialHelper.getDiscoverWordStep = function (options) {
    options = options || {};
    const sceneComponent = cleverapps.Scenes.GetSceneComponent(WordGameSceneComponent);

    let highlights = [sceneComponent.currentView, cleverapps.Scenes.GetMovingNode(), cleverapps.Scenes.GetSceneComponent(GameSceneComponent).exclamationView, sceneComponent.keypadView];
    if (options.highlights) {
        highlights = highlights.concat(options.highlights);
    }

    const force = options.force || {
        text: ""
    };

    const step = { 
        onStart: function () {
            this.word = typeof options.word === "function" ? options.word() : options.word;

            force.finger = function () {
                return {
                    path: Game.currentGame.keypad.findWordIndexes(this.word),
                    pathColor: options.pathColor,
                    releaseDelay: 0.3
                };
            }.bind(this);

            this.force = cleverapps.forces.create(sceneComponent.keypadView, force, {
                highlights,
                importantNodes: options.importantNodes
            });

            if (!this.force) {
                cleverapps.throwAsync(
                    "Not created force for tutorial step",
                    `force element: ${sceneComponent.keypadView}` && sceneComponent.keypadView.isRunning(),
                    `force id: ${force.id}`,
                    `force is shown: ${cleverapps.forces.isShown(force)}`,
                    `active tutorial: ${cleverapps.tutorial.getActive().name}`,
                    `user level: ${cleverapps.user.currentPhysicalLevel.episode}/${cleverapps.user.currentPhysicalLevel.level}`,
                    `game level: ${Game.currentGame.level.episodeNo}/${Game.currentGame.level.levelNo}/${cleverapps.settings.language}`
                );
            }

            const keypad = Game.currentGame.keypad;
            keypad.on("touchBegan", this.force.stopFinger.bind(this.force), this.force);
            keypad.on("attempt", this.force.resumeFinger.bind(this.force), this.force);
            keypad.on("reset", this.force.resumeFinger.bind(this.force), this.force);

            cleverapps.tutorial.on("discover_word", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
        }
    };

    return new TutorialStep(step);
};